import { Textarea } from "@chakra-ui/react"
import { ContactInputProps } from "@definitions/types"
import { Controller } from "react-hook-form"

const ContactTextArea = ({ id, placeholder, ...props }: ContactInputProps) => {
  return (
    <Controller
      {...props}
      render={({ field: { ref, ...restField } }) => (
        <Textarea
          id={id}
          variant={"flushed"}
          placeholder={placeholder}
          borderColor={"brand.black"}
          focusBorderColor={"brand.primary"}
          fontSize={"2xl"}
          color={"brand.primary"}
          lineHeight={"1em"}
          resize={"vertical"}
          _placeholder={{ color: "gray.300" }}
          ref={ref}
          {...restField}
        />
      )}
    />
  )
}

export default ContactTextArea
